<div *ngrxLet="viewModel$; let viewModel" class="flex items-center">
  @if (!viewModel.isLoading) {
    <button mat-icon-button
      [disableRipple]="true"
      id="claimAndCleanCompletionTimestamp"
      class="parent-location-action"
      [disabled]="!viewModel.canToggleCcCompletion"
      (click)="toggleClaimCleanCompletion(viewModel.params.data)"
      appGtagEvent
      trackOn="click"
          action="{{ viewModel.params.data?.claimAndCleanCompletionTimestamp ?
                  'Unmark location as completed' : 'Mark location as completed' }}"
      category="C&C actions [overhaul]">
      <mat-icon
        [matTooltip]="viewModel.tooltip"
        [ngClass]="{'text-pink-50': viewModel.params.data?.claimAndCleanCompletionTimestamp }"
        [svgIcon]="!viewModel.params.data?.claimAndCleanCompletionTimestamp ? 'event_available_outline' : 'event_available'">
      </mat-icon>
    </button>
  }
  @if (viewModel.isLoading) {
    <div
      class="w-[48px] h-[48px] flex justify-center items-center">
      <mat-spinner [diameter]="20"></mat-spinner>
    </div>
  }
  <span>{{ viewModel.params.valueFormatted }}</span>
</div>
